import { IActionOptions } from '@interfaces/IActionOptions';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { INote } from '@interfaces/INoteData';
import {
  INoteQParams,
  IStudentQParams,
  ITeacherQParams,
} from '@interfaces/IQParams';
import {
  IStudentFinalResults,
  IStudentGenerateFinalResults,
  IStudentResults,
} from '@interfaces/IStudentResults';
import { IUsersPagination } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EUsersViewActions {
  GetUsersRequest = '[Users] Get Users Request',
  GetUsersSuccess = '[Users] Get Users Success',
  GetUsersFailure = '[Users] Get Users Failure',
  ClearUsers = '[Users] Clear Users',

  GetStudentsRequest = '[Users] Get Students Request',
  GetStudentsSuccess = '[Users] Get Students Success',
  GetStudentsFailure = '[Users] Get Students Failure',
  ClearStudents = '[Users] Clear students',

  GetTeachersRequest = '[Users] Get Teachers Request',
  GetTeachersSuccess = '[Users] Get Teachers Success',
  GetTeachersFailure = '[Users] Get Teachers Failure',
  ClearTeachers = '[Users] Clear Teachers',

  GetCheckingTeachersRequest = '[Users] Get Checking Teachers Request',
  GetCheckingTeachersSuccess = '[Users] Get Checking Teachers Success',
  GetCheckingTeachersFailure = '[Users] Get Checking Teachers Failure',
  ClearCheckingTeachers = '[Users] Clear Checking Teachers',

  GetUsersNotesRequest = '[Users] Get Users Notes Request',
  GetUsersNotesSuccess = '[Users] Get Users Notes Success',
  GetUsersNotesFailure = '[Users] Get Users Notes Failure',
  ClearUsersNotes = '[Users] Clear Users Notes',

  GetUserNoteByIdRequest = '[Users] Get User Note By Id Request',
  GetUserNoteByIdSuccess = '[Users] Get User Note By Id Success',
  GetUserNoteByIdFailure = '[Users] Get User Note By Id Failure',
  ClearGetUserNoteById = '[Users] Clear Get User Note By Id',

  GetStudentGroupsResultsRequest = '[Users] Get Student Groups Results Request',
  GetStudentGroupsResultsSuccess = '[Users] Get Student Groups Results Success',
  GetStudentGroupsResultsFailure = '[Users] Get Student Groups Results Failure',
  ClearStudentGroupsResults = '[Users] Clear Student Groups Results',

  GenerateStudentResultsRequest = '[Users] Send Generate Student Results Request',
  GenerateStudentResultsSuccess = '[Users] Send Generate Student Results Success',
  GenerateStudentResultsFailure = '[Users] Send Generate Student Results Failure',
  ClearGenerateStudentResults = '[Users] Clear Generate Student Results',

  GetStudentFinalResultsRequest = '[Users] Get Student Final Results Request',
  GetStudentFinalResultsSuccess = '[Users] Get Student Final Results Success',
  GetStudentFinalResultsFailure = '[Users] Get Student Final Results Failure',
  ClearStudentFinalResults = '[Users] Clear Student Final Results',
}

export class GetUsersRequest implements Action {
  public readonly type = EUsersViewActions.GetUsersRequest;

  constructor(public options?: IActionOptions) {}
}

export class GetUsersSuccess implements Action {
  public readonly type = EUsersViewActions.GetUsersSuccess;

  constructor(public payload: IUsersPagination) {}
}

export class GetUsersFailure implements Action {
  public readonly type = EUsersViewActions.GetUsersFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearUsers implements Action {
  public readonly type = EUsersViewActions.ClearUsers;
}

export class GetStudentsRequest implements Action {
  public readonly type = EUsersViewActions.GetStudentsRequest;

  constructor(public groupId: number, public qParams?: IStudentQParams) {}
}

export class GetStudentsSuccess implements Action {
  public readonly type = EUsersViewActions.GetStudentsSuccess;

  constructor(public students: IUsersPagination) {}
}

export class GetStudentsFailure implements Action {
  public readonly type = EUsersViewActions.GetStudentsFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearStudents implements Action {
  public readonly type = EUsersViewActions.ClearStudents;
}

export class GetTeachersRequest implements Action {
  public readonly type = EUsersViewActions.GetTeachersRequest;

  constructor(public groupId: number, public qParams?: ITeacherQParams) {}
}

export class GetTeachersSuccess implements Action {
  public readonly type = EUsersViewActions.GetTeachersSuccess;

  constructor(public teachers: IUsersPagination) {}
}

export class GetTeachersFailure implements Action {
  public readonly type = EUsersViewActions.GetTeachersFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearTeachers implements Action {
  public readonly type = EUsersViewActions.ClearTeachers;
}

export class GetUsersNotesRequest implements Action {
  public readonly type = EUsersViewActions.GetUsersNotesRequest;

  constructor(public params: INoteQParams) {}
}

export class GetUsersNotesSuccess implements Action {
  public readonly type = EUsersViewActions.GetUsersNotesSuccess;

  constructor(public payload: INote[]) {}
}

export class GetUserNotesFailure implements Action {
  public readonly type = EUsersViewActions.GetUsersNotesFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearUsersNotes implements Action {
  public readonly type = EUsersViewActions.ClearUsersNotes;
}

export class GetUserNoteByIdRequest implements Action {
  public readonly type = EUsersViewActions.GetUserNoteByIdRequest;

  constructor(public id: number) {}
}

export class GetUserNoteByIdSuccess implements Action {
  public readonly type = EUsersViewActions.GetUserNoteByIdSuccess;

  constructor(public payload: INote) {}
}

export class GetUserNoteByIdFailure implements Action {
  public readonly type = EUsersViewActions.GetUserNoteByIdFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGetUserNoteById implements Action {
  public readonly type = EUsersViewActions.ClearGetUserNoteById;
}

export class GetStudentGroupsResultsRequest implements Action {
  public readonly type = EUsersViewActions.GetStudentGroupsResultsRequest;

  constructor(public userId: number) {}
}

export class GetStudentGroupsResultsSuccess implements Action {
  public readonly type = EUsersViewActions.GetStudentGroupsResultsSuccess;

  constructor(public payload: IStudentResults[]) {}
}

export class GetStudentGroupsResultsFailure implements Action {
  public readonly type = EUsersViewActions.GetStudentGroupsResultsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearStudentGroupsResults implements Action {
  public readonly type = EUsersViewActions.ClearStudentGroupsResults;
}

export class GenerateStudentResultsRequest implements Action {
  public readonly type = EUsersViewActions.GenerateStudentResultsRequest;

  constructor(public id: number, public periods: number[]) {}
}

export class GenerateStudentResultsSuccess implements Action {
  public readonly type = EUsersViewActions.GenerateStudentResultsSuccess;

  constructor(public payload: IStudentGenerateFinalResults) {}
}

export class GenerateStudentResultsFailure implements Action {
  public readonly type = EUsersViewActions.GenerateStudentResultsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearGenerateStudentResults implements Action {
  public readonly type = EUsersViewActions.ClearGenerateStudentResults;
}

export class GetStudentFinalResultsRequest implements Action {
  public readonly type = EUsersViewActions.GetStudentFinalResultsRequest;

  constructor(public id: number) {}
}

export class GetStudentFinalResultsSuccess implements Action {
  public readonly type = EUsersViewActions.GetStudentFinalResultsSuccess;

  constructor(public payload: IStudentFinalResults[]) {}
}

export class GetStudentFinalResultsFailure implements Action {
  public readonly type = EUsersViewActions.GetStudentFinalResultsFailure;

  constructor(public errors: IFormErrors) {}
}

export class ClearStudentFinalResults implements Action {
  public readonly type = EUsersViewActions.ClearStudentFinalResults;
}

export type UsersViewActions =
  | GetUsersRequest
  | GetUsersSuccess
  | GetUsersFailure
  | ClearUsers
  | GetStudentsRequest
  | GetStudentsSuccess
  | GetStudentsFailure
  | ClearStudents
  | GetTeachersRequest
  | GetTeachersSuccess
  | GetTeachersFailure
  | ClearTeachers
  | GetUsersNotesRequest
  | GetUsersNotesSuccess
  | GetUserNotesFailure
  | ClearUsersNotes
  | GetUserNoteByIdRequest
  | GetUserNoteByIdSuccess
  | GetUserNoteByIdFailure
  | ClearGetUserNoteById
  | GetStudentGroupsResultsRequest
  | GetStudentGroupsResultsSuccess
  | GetStudentGroupsResultsFailure
  | ClearStudentGroupsResults
  | GenerateStudentResultsRequest
  | GenerateStudentResultsSuccess
  | GenerateStudentResultsFailure
  | ClearGenerateStudentResults
  | GetStudentFinalResultsRequest
  | GetStudentFinalResultsSuccess
  | GetStudentFinalResultsFailure
  | ClearStudentFinalResults;
